import React from 'react';

import StyledToolTip from '@rental-manager/components/StyledTooltip';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

const DepositDateTooltipComponent = (): JSX.Element | null => {
  return (
    <StyledToolTip className="Dashboard-ledger-tooltip" iconName="help-circle-fill">
      <Text>
        Rent payments are typically deposited within two business days. In some cases, deposits follow a standard
        five-business-day timeline.
      </Text>
    </StyledToolTip>
  );
};

export default DepositDateTooltipComponent;
